import { render, staticRenderFns } from "./TimeTableForGroup.vue?vue&type=template&id=1bb4c592&"
import script from "./TimeTableForGroup.vue?vue&type=script&lang=js&"
export * from "./TimeTableForGroup.vue?vue&type=script&lang=js&"
import style0 from "./TimeTableForGroup.vue?vue&type=style&index=0&id=1bb4c592&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports